import { PayloadAction, createEntityAdapter, createSlice } from '@reduxjs/toolkit';

export enum ProgressState {
    WAIT,
    IN_PROGRESS,
    DONE,
    ERROR
}
export interface ProgressInfo {
    id: string;
    filename?: string;
    progress?: number;
    state: ProgressState;
    message?: string;
}

export const progressAdapter = createEntityAdapter<ProgressInfo>({ selectId: ({ id }) => id });

export const uplooadsSlice = createSlice({
    name: 'uploads',
    initialState: progressAdapter.getInitialState(),
    reducers: {
        add(state, { payload: { id, filename } }: PayloadAction<Omit<ProgressInfo, 'progress' | 'state'>>) {
            progressAdapter.addOne(state, { id, filename, progress: 0, state: ProgressState.WAIT });
        },
        update(state, { payload: { id, progress } }: PayloadAction<Omit<ProgressInfo, 'filename' | 'state'>>) {
            progressAdapter.updateOne(state, { id, changes: { progress, state: ProgressState.IN_PROGRESS } });
        },
        delete(state, { payload }: PayloadAction<string>) {
            progressAdapter.updateOne(state, { id: payload, changes: { progress: 100, state: ProgressState.DONE } });
        },
        error(state, { payload: { id, message } }: PayloadAction<Pick<ProgressInfo, 'id' | 'message'>>) {
            progressAdapter.updateOne(state, { id, changes: { progress: 100, state: ProgressState.ERROR, message } });
        }
    }
});

export const downloadSlice = createSlice({
    name: 'download',
    initialState: progressAdapter.getInitialState(),
    reducers: {
        add(state, { payload: { id, filename } }: PayloadAction<Omit<ProgressInfo, 'progress' | 'state'>>) {
            progressAdapter.addOne(state, { id, filename, progress: 0, state: ProgressState.WAIT });
        },
        update(state, { payload: { id, progress } }: PayloadAction<Omit<ProgressInfo, 'filename' | 'state'>>) {
            progressAdapter.updateOne(state, { id, changes: { progress, state: ProgressState.IN_PROGRESS } });
        },
        delete(state, { payload }: PayloadAction<string>) {
            progressAdapter.updateOne(state, { id: payload, changes: { progress: 100, state: ProgressState.DONE } });
        },
        error(state, { payload: { id, message } }: PayloadAction<Pick<ProgressInfo, 'id' | 'message'>>) {
            progressAdapter.updateOne(state, { id, changes: { progress: 100, state: ProgressState.ERROR, message } });
        }
    }
});
